import {Text, TouchableOpacity} from "react-native";
import React, {useEffect, useState} from "react";
import {
    BUTTON_BORDER_COLOR,
    FONT_FAMILY,
    FONT_FAMILY_BOLDER,
    FONT_SIZE,
    FONT_SIZE_S,
    FONT_SIZE_XL,
    SUBTEXT_PRIMARY_COLOR
} from "../constants/styleConstants";
import {useSelector} from "react-redux";
import {getComponentColor, getConfig} from "../reducers/configSlice";
import {MaterialIndicator} from "react-native-indicators";
import {hexToRGB, setContrast} from '../services/helpers/stylingHelpers';
import {useDeviceOrientation} from '@react-native-community/hooks';
import {RC} from "../styles/defaultStyles";

const Button = ({secondary = false, loading = false, disabled = false, onPress, text, subtext = null, timeout = null, timeoutCallback = null, timeoutHidden = false, additionalStyle = null, additionalTextStyle = null}) => {
    const config = useSelector(getConfig)
    const [count, setCount] = useState(null)
    const [styles, setStyles] = useState(getStyles())
    const componentColor = useSelector(getComponentColor)

    const orientation = useDeviceOrientation()
    useEffect( () => {
        setStyles(getStyles(!!orientation.portrait))
    }, [orientation])

    useEffect(() => {
        if (timeout && timeoutCallback) {
            setCount(timeout)

            let interval = setInterval(() => {
                setCount(lastTimerCount => {
                    lastTimerCount <= 1 && clearInterval(interval)
                    return lastTimerCount - 1
                })
            }, 1000)

            let callback = setTimeout(() => {
                timeoutCallback()
            }, timeout * 1000)

            return () => {
                clearInterval(interval);
                clearTimeout(callback)
            }
        }
    }, []);

    const buttonColor = Color(componentColor).rgb().string()
    const buttonTextColor = setContrast(Color(config.background_color).object())
    const buttonSubTextColor = hexToRGB(buttonTextColor, 0.65)

    return(
        <TouchableOpacity
            disabled={disabled}
            onPress={onPress}
            style={[styles.buttonContainer, {backgroundColor: buttonColor ? buttonColor : '#5B41D9'}, disabled && {opacity: 0.35}, additionalStyle]}
        >
            <Text style={[styles.buttonText, {color: buttonTextColor ? buttonTextColor : '#fff'}, additionalTextStyle]}>{text + (timeout && timeoutCallback && !timeoutHidden ? (" (" + count + ")") : '')}</Text>
            {loading && <MaterialIndicator style={styles.loadingIndicator} size={FONT_SIZE_XL}  trackWidth={5} color={buttonTextColor ? buttonTextColor : '#fff'}/>}
            {subtext && <Text style={[styles.buttonSubText, {color: buttonSubTextColor}]}>{subtext}</Text>}
        </TouchableOpacity>
    )
}

const getStyles = (portrait = true) => {
    return {
        buttonContainer: {
            height: RC(portrait).buttonHeight(),
            borderWidth: RC(portrait).buttonBorderWidth(),
            borderRadius: RC(portrait).buttonBorderRadius(),
            borderColor: BUTTON_BORDER_COLOR,
            justifyContent: 'center',
            alignItems: 'center',
        },
        buttonText: {
            fontSize: FONT_SIZE,
            fontFamily: FONT_FAMILY_BOLDER
        },
        buttonSubText: {
            fontSize: FONT_SIZE_S,
            fontFamily: FONT_FAMILY,
            color: SUBTEXT_PRIMARY_COLOR
        },
        loadingIndicator: {
            position: 'absolute',
            right: RC(portrait).inputPadding()
        }
    }
};

export default Button